import { render, staticRenderFns } from "./MordaLenta.vue?vue&type=template&id=d572fa00"
import script from "./MordaLenta.vue?vue&type=script&lang=js"
export * from "./MordaLenta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports